module.exports = __webpack_public_path__ + "src/assets/img/icon-pix.edf82604.svg";